import * as React from "react";
import classNames from "classnames";
import { useWasSeenByUser } from "@grandvisionhq/analytics";
import { Context } from "@grandvisionhq/carts-v2";
import { ProductBlock } from "@grandvisionhq/lib-visuals";
import { useProductLink } from "../../../../../../../../utils/utils/use-product-link.js";
import { pushProductImpressions, pushProductClick } from "../../../../../../utils/lib-components/RecommendedProducts/utils/data-layer.js";
import { getZeroDiscount } from "../../../../../../utils/lib-components/RecommendedProducts/utils/get-zero-discount.js";
import { getProductRecommendationAction } from "../../../../../../utils/lib-components/RecommendedProducts/utils/mappers.js";
/* empty css                                */
import { ProductBlockAction } from "../../../../components/ProductBlockAction/lib-components/RecommendedProducts/components/ProductRecommendationBlock/components/ProductBlockAction/ProductBlockAction.js";
import { pushAddFromMiniCartEvent } from "../../../../../../../../DataLayer/DataLayer/data-layer.js";
const ProductRecommendationBlock = ({
  className,
  recommendation,
  position,
  shouldRenderAsCard,
  tabIndex
}) => {
  const link = useProductLink(recommendation.slug, recommendation.sku, recommendation.productType);
  const { wasSeen, ref } = useWasSeenByUser();
  React.useEffect(() => {
    if (wasSeen) {
      pushProductImpressions(recommendation, position);
    }
  }, [position, recommendation, wasSeen]);
  const handleClick = () => {
    pushProductClick(recommendation, position);
  };
  const { cart } = Context.useCart();
  const handleAddProduct = () => {
    pushAddFromMiniCartEvent(
      recommendation.sku,
      recommendation.name,
      recommendation.brand,
      recommendation.productType,
      recommendation.price.value.centAmount,
      recommendation.price.discounted ? recommendation.price.discounted.value.centAmount : recommendation.price.value.centAmount,
      cart?.id
    );
  };
  const frontImage = recommendation.images?.[0];
  const angleImage = recommendation.images?.[1];
  const tag = getZeroDiscount(recommendation) || recommendation.tags?.[0];
  const heading = recommendation.brand;
  const caption = recommendation.name || recommendation.brandModel || "";
  const action = getProductRecommendationAction(recommendation.action ?? void 0);
  return /* @__PURE__ */ React.createElement(
    ProductBlock.Outer,
    {
      className: classNames(className, "product-recommendation-block", {
        "product-recommendation-block--card": shouldRenderAsCard
      }),
      ref
    },
    /* @__PURE__ */ React.createElement(ProductBlock.Inner, null, /* @__PURE__ */ React.createElement(ProductBlock.Header, null, /* @__PURE__ */ React.createElement(ProductBlock.Header.Left, { tag })), /* @__PURE__ */ React.createElement(ProductBlock.Details, { href: link, onClick: handleClick, tabIndex }, /* @__PURE__ */ React.createElement(ProductBlock.Details.Heading, null, heading), /* @__PURE__ */ React.createElement(ProductBlock.Details.Caption, null, caption)), /* @__PURE__ */ React.createElement(
      ProductBlock.Images,
      {
        href: link,
        onClick: handleClick,
        frontUrl: frontImage?.url || "",
        frontAlt: frontImage?.label || void 0,
        angleUrl: angleImage?.url
      }
    ), /* @__PURE__ */ React.createElement(
      ProductBlock.Pricing,
      {
        originalPrice: recommendation.price.value.centAmount,
        discountedPrice: recommendation.price.discounted?.value.centAmount,
        discountLabel: recommendation.promotionLabel || "",
        currency: recommendation.price.value.currencyCode,
        isCentAmount: true
      }
    ), action && /* @__PURE__ */ React.createElement(ProductBlock.Footer, null, /* @__PURE__ */ React.createElement(
      ProductBlockAction,
      {
        activeSku: recommendation.sku,
        productType: recommendation.productType,
        action,
        onAddProduct: handleAddProduct,
        tabIndex
      }
    )))
  );
};
export {
  ProductRecommendationBlock
};
//# sourceMappingURL=ProductRecommendationBlock.js.map
